import firebase from 'firebase'

var firebaseConfig = {
  apiKey: "AIzaSyC8bDxPXFDUOOBw8a3XE6vNhk1KJhoUfwY",
  authDomain: "fpj-main-app-d2360.firebaseapp.com",
  databaseURL: "https://fpj-main-app-d2360.firebaseio.com",
  projectId: "fpj-main-app-d2360",
  storageBucket: "fpj-main-app-d2360.appspot.com",
  messagingSenderId: "945284755600",
  appId: "1:945284755600:web:61cdbc7ead8316d057e815",
  measurementId: "G-JZZ64KGQMY"
};
  // Initialize Firebase
const fire_base =  firebase.initializeApp(firebaseConfig);



export default fire_base